export const APPLICATION_URL_GOOGLE_PLAY = 'https://play.google.com/store/apps/details?id=com.capitalgroup.pro';
export const APPLICATION_URL_APPLE_STORE = 'https://apps.apple.com/us/app/lumin-by-capital-group/id1454038882';
